import * as React from "react";
import CDN from "../../Utilities/Platform/CDN";

export default class ShopfrontLogo extends React.Component {
    public render(): React.ReactNode {
        return (
            <img
                alt="Shopfront Logo"
                src={CDN("/imgs/logo.png")}
                className="shopfront-logo"
            />
        );
    }
}
